import styled from '@emotion/styled';
import { MEDIA_QUERY, COLORS3 as COLORS, FONT, SPACING } from '../../../styles/emotion';
import { fieldHeight, fieldHeightMobile, FormLabel } from '../form.styles';
import {
  dropdownInputBaseStyles,
  DropdownInputProps,
} from '../common/DropdownTrigger/DropdownTrigger.styles';

// This is here for backward compatibility, web-wedding imported these styles
// from this file.
export { StyledCaret, InputSection, Input } from '../common/DropdownTrigger/DropdownTrigger.styles';

export const DropdownSection = styled.div<{
  position: string;
}>`
  ${({ position }) => `position: ${position};`}
`;

export const DropdownListHeader = styled.div`
  border-bottom: 1px solid ${COLORS.BLACK_030};
  padding: ${SPACING.MD};
  position: relative;
`;

export const DropdownEmptyState = styled.div`
  padding: ${SPACING.MD};
  position: relative;
`;

export const DropdownFieldContainer = styled.div<{
  inline?: boolean;
  alignment: 'vertical' | 'horizontal';
  hasLabel: boolean;
  hasMinWidth: boolean;
}>`
  color: ${COLORS.BLACK_100};
  font-size: ${FONT.FONT_SIZE_SMALL};
  ${({ hasMinWidth }) => hasMinWidth && `min-width: 150px;`}
  ${({ inline }) => inline && `display: inline-block;`}

  ${({ alignment, hasLabel }) =>
    alignment === 'horizontal'
      ? `display: flex;
      ${FormLabel} {
        line-height: ${fieldHeight}px;
        ${MEDIA_QUERY.MOBILE} {
          line-height: ${fieldHeightMobile}px;
        }
      }
      ${DropdownSection} {
        ${hasLabel ? 'margin-left: 8px;' : ''}
      }`
      : `${DropdownSection} {
        ${hasLabel ? 'margin-top: 8px;' : ''}
      }`}
`;

export const DropdownSelect = styled.select<DropdownInputProps>`
  ${(props) => dropdownInputBaseStyles(props)};
  appearance: none;
  padding-bottom: ${SPACING.XS};
  padding-top: ${SPACING.XS};
`;
